import { Chart } from 'react-chartjs-2';

import { COLOR_ACCENT, COLOR_ACCENT_TOP } from './performanceStatsUtils';

export const ROUNDED_GRADIENT_BAR_TYPE = 'roundedGradientBar';

const BAR_CORNER_RADIUS = 4;

const drawRoundedGradientBar = (ctx, view) => {
    const isDrawable = [view.x, view.y, view.base, view.width].every(Number.isFinite);
    if (!isDrawable) { return; }
    const halfWidth = view.width / 2;
    const left = view.x - halfWidth;
    const right = view.x + halfWidth;
    const top = view.y;
    const bottom = view.base;
    const radius = Math.min(BAR_CORNER_RADIUS, Math.abs(bottom - top), halfWidth);
    const gradient = ctx.createLinearGradient(left, bottom, right, top);
    gradient.addColorStop(0, COLOR_ACCENT);
    gradient.addColorStop(1, COLOR_ACCENT_TOP);
    ctx.save();
    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.moveTo(left, bottom);
    ctx.lineTo(left, top + radius);
    ctx.quadraticCurveTo(left, top, left + radius, top);
    ctx.lineTo(right - radius, top);
    ctx.quadraticCurveTo(right, top, right, top + radius);
    ctx.lineTo(right, bottom);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
};

let isRegistered = false;

export const registerRoundedGradientBarType = () => {
    if (isRegistered) { return; }
    isRegistered = true;
    const RoundedGradientRectangle = Chart.elements.Rectangle.extend({
        draw() {
            drawRoundedGradientBar(this._chart.ctx, this._view);
        },
    });
    Chart.defaults[ROUNDED_GRADIENT_BAR_TYPE] = Chart.helpers.clone(Chart.defaults.bar);
    Chart.defaults.global.datasets[ROUNDED_GRADIENT_BAR_TYPE] = Chart.helpers.clone(Chart.defaults.global.datasets.bar);
    Chart.controllers[ROUNDED_GRADIENT_BAR_TYPE] = Chart.controllers.bar.extend({
        dataElementType: RoundedGradientRectangle,
    });
};
